import {
  IdType, BaseEntity, EntityDateInfo, EntityStatus,
} from './common';
import { InviteTemplate } from './fhq-invite-template';
import { PermissionTemplateCode } from './permission';

export enum FhqOutgoing {
  BOTH = 'Both',
  EMAIL = 'Email',
  SMS = 'SMS',
}

export enum FhqOptional {
  EMAIL = 'Email',
  SMS = 'SMS',
}

export enum WhitelistMode {
  IP_CIDR = 1,
  IP_RANGE = 2,
  IP_SPECIFIC = 3,
}

export enum FHQStatus {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
}

export enum FhqItemStatus {
  COMPLETED = 'Completed',
  IN_PROGRESS = 'In Progress',
  INVITE_FAILED = 'Invite Failed',
  NOT_INVITED = 'Not Invited',
  SENT = 'Sent',
  SCHEDULED = 'Scheduled',
}

// Site Fhq
export interface SiteFhqDto {
  lockOnSubmitIsEnabled: boolean;
  kioskIsEnabled: boolean;
}

export interface SiteFhq extends SiteFhqDto, BaseEntity {
  name: string;
  status?: EntityStatus;
}

// Site General Settings
export interface FhqGeneralSettingDto {
  outgoing: FhqOutgoing;
  emailIsOptional: boolean;
  smsIsOptional: boolean;
  kioskIsEnabled: boolean;
  kioskNewPatientRegistrationIsEnabled: boolean;
  status?: FHQStatus;
}

export interface FhqGeneralSetting extends FhqGeneralSettingDto, BaseEntity, EntityDateInfo {}

// Site Ip Whitelist
export interface IpWhitelistRecordDto {
  siteId: IdType;
  modeId: IdType;
  label: string | null;
  ip: string;
  cidrId: IdType;
  ipFrom: string;
  ipTo: string;
  status?: FHQStatus;
}

export type IpWhitelistRecordUpdateDto = Omit<IpWhitelistRecordDto, 'siteId'>;

export interface IpWhitelistRecord extends IpWhitelistRecordUpdateDto, BaseEntity, EntityDateInfo {}

export interface FhqInvitationSettingDto {
  isAutomatedReminder: boolean;
  isAutomatedInvitation: boolean;
  invitationDaysInAdvance: number;
  reminderDaysIntervalIfAppointmentSet: number;
  reminderDaysIntervalIfAppointmentNotset: number;
  maxRemindersIfAppointmentSet: number;
  maxRemindersIfAppointmentNotset: number;
  emailTemplateId: string;
  smsTemplateId: string;
  reminderEmailTemplateId: string;
  reminderSmsTemplateId: string;
}

export interface FhqInvitationSetting extends FhqInvitationSettingDto, BaseEntity, EntityDateInfo {}

export interface FhqUserListItemDto {
  userId: IdType;
  siteFhqId: IdType;
}

export interface FhqUserListItem extends BaseEntity {
  userName: string;
  email: string;
  permissionTemplateCode: PermissionTemplateCode;
  permissionsIsCustomized: boolean;
  userId: IdType;
  status?: FHQStatus;
}

export interface FhqHelpContactCreateDto {
  siteFhqId: IdType;
  name: string | null;
  email: string | null;
  phone: string | null;
  note: string | null;
}

export type FhqHelpContactUpdateDto = Omit<FhqHelpContactCreateDto, 'siteFhqId'>;

export interface FhqHelpContact extends FhqHelpContactUpdateDto, BaseEntity, EntityDateInfo {}

export type FhqInvitation = {
  siteFhqId: IdType;
  settings: FhqInvitationSetting;
  status?: FHQStatus;
};

export type FhqUsers = {
  siteFhqId: IdType;
  users: FhqUserListItem[];
  status?: FHQStatus;
};

export type FhqInviteTemplates = {
  siteFhqId: IdType;
  inviteTemplates: InviteTemplate[];
};
